import { pipe } from 'fp-ts/function';
import { connect } from 'react-redux';
import { ApplicationState, CommanderThunkDispatch, WithAvailabilityBlockId } from '@mews-commander/types';
import { Card, withAsyncContainer } from '@mews-commander/ui';
import { AsyncMetaState, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { TimeUnit } from '@mews/enums';
import { commanderForm, validation } from '@mews-commander/legacy-form';
import { getServiceTimeUnit } from '@mews-commander/legacy-entities/src/ducks';
import {
    getEditFormValues,
    getFormEndDateString,
    getFormStartDateString,
    hasAvailabilityBlockEntityFormFailed,
    isAvailabilityBlockEntityFormFetching,
} from '../selectors';
import { FormValues } from '../types';
import { submitAvailabilityBlockUpdateForm } from '../actions';
import AvailabilityBlockFormFields from './AvailabilityBlockFormFields';
import {
    AvailabilityBlockEntityFormStateProps,
    AvailabilityBlockFormDispatchProps,
    BaseFormProps,
    getConstraints,
} from './common';

type AvailabilityBlockEditFormBaseProps = BaseFormProps & WithAvailabilityBlockId;

interface AvailabilityBlockEditFormStateProps extends AsyncMetaState, AvailabilityBlockEntityFormStateProps {
    initialValues?: Partial<FormValues>;
}

const AvailabilityBlockEditForm = pipe(
    AvailabilityBlockFormFields,
    commanderForm({
        submitButtonProps: { variant: 'primary' },
        submitLabel: <LocalizedText textKey={TextKey.Update} />,
        validate: validation(getConstraints),
    }),
    withAsyncContainer,
    connect<
        AvailabilityBlockEditFormStateProps,
        AvailabilityBlockFormDispatchProps,
        AvailabilityBlockEditFormBaseProps,
        ApplicationState
    >(
        (state, { form, availabilityBlockId, serviceId }) => ({
            startDate: getFormStartDateString(state, { form }),
            endDate: getFormEndDateString(state, { form }),
            // @ts-expect-error
            initialValues: getEditFormValues(state, { id: availabilityBlockId, serviceId }),
            isFetching: isAvailabilityBlockEntityFormFetching(state, { scope: form }),
            hasFailed: hasAvailabilityBlockEntityFormFailed(state, { scope: form }),
            timeUnit: getServiceTimeUnit(state, { id: serviceId }) as TimeUnit,
        }),
        (dispatch: CommanderThunkDispatch, { availabilityBlockId }) => ({
            onSubmit: (values: FormValues) =>
                dispatch(submitAvailabilityBlockUpdateForm({ availabilityBlockId, ...values })),
        })
    )
);

export const AvailabilityBlockFormEditFormModal = (props: AvailabilityBlockEditFormBaseProps) => (
    <Card>
        <AvailabilityBlockEditForm {...props} />
    </Card>
);
